"use strict";

exports.__esModule = true;

var _RouterContext = require("react-router/RouterContext");

var _RouterContext2 = _interopRequireDefault(_RouterContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RouterContext2.default; // Written in this round about way for babel-transform-imports


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/RouterContext.js
 ** module id = 507
 ** module chunks = 0
 **/